import { useState } from 'react';
import FieldNameRenderer from 'components/TemplatePreview/Fields/FieldNameRenderer';
import RecordVideo from 'components/RecordVideo';

const TakeVideo = ({ item, preview = true, onChangeCb, isEmulatorView }) => {
  const [value, setValue] = useState<any>([]);

  const handleChange = (filesUrls) => {
    if (onChangeCb) {
      const updatedValues = [...(filesUrls ?? [])];
      setValue(updatedValues);
      onChangeCb && onChangeCb(updatedValues);
    }
  };

  return (
    <FieldNameRenderer
      preview={preview}
      fieldName={item.description}
      item={item}
      isEmulatorView={isEmulatorView}
    >
      <RecordVideo
        attachments={value ?? []}
        onChangeCb={handleChange}
        isShowStatic={true}
      />
    </FieldNameRenderer>
  );
};

export default TakeVideo;
